import { DataBean } from "../DataBean";

export class AttentionPointAgenda extends DataBean {

    public async getAttentionPointAvailableForAgenda(idln: number, date: any): Promise<any> {
        return this.getCustomService(
            "QuickTurnService",
            "java.util.List_getAttentionPointAvailableForAgenda_Number_java.util.Date",
            [idln, date]);
    }

    public async getAvailableAppointment(year: number, month: number, idln: number): Promise<any> {
        return this.getCustomService(
            "QuickTurnService",
            "java.util.List_getAvailableAppointment_Number_Number_Number",
            [year, month, idln]);
    }

    public async getAppointments(idln: number, date: any, idAttentionPoint: number | null): Promise<any> {
        return this.getCustomService(
            "QuickTurnService",
            "java.util.List_getAppointments_Number_java.util.Date_Number",
            [idln, date, idAttentionPoint]);
    }

}
